import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APICvRicevuti {

    getUrlDomain(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = location.protocol + "//emtool.local/";
        }

        if (location.hostname != "localhost") {

            result = "https://companysupport.eu/";

        }

        return result + nome_metodo;


    }

    async initFilter(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_prod", v_prod);

        return axios.post(this.getUrlDomain("TwoRecruitCvRicFiltersApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async deleteCvRicevuti(id, user) {

        let formData = new FormData();

        formData.append("id", id);
        formData.append("username", user);

        return axios.post(this.getUrlDomain("TwoRecruitCvRicDeleteApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }


}

export default new APICvRicevuti({
    url: "https://services.ebadge.it/public/api/"
})
